import React from 'react';

import { Box, Link, Text } from '@r-client/shared/ui/core';

import styles from './crowdcast-widget.module.scss';

interface ICrowdcastWidgetProps {
  title: string;
  url: string;
  dataTestId?: string;
}

export const CrowdcastWidget: React.FC<
  React.PropsWithChildren<ICrowdcastWidgetProps>
> = ({ title, url, dataTestId }) => {
  return (
    <Box className={styles.wrapper}>
      <iframe
        data-testid={dataTestId}
        title={title}
        src={`${url}?navlinks=false&embed=true`}
        className={styles.frame}
      ></iframe>
      <Link
        className={styles.link}
        target="_blank"
        rel="noreferrer"
        href="https://www.crowdcast.io/?utm_source=embed&utm_medium=website&utm_campaign=embed"
      >
        <Text as="span" type="bodySmall" color="gray60">
          powered by crowdcast
        </Text>
      </Link>
    </Box>
  );
};
